import React from "react";
import "./navBar.css";
import title from "../../images/Title.png";

function NavBar() {
  return (
    <div className="nav-wrapper">
      <nav className="nav">
        <img src={title} alt="title" className="nav-title" />
      </nav>
    </div>
  );
}

export default NavBar;
